<template>
  <div>
    <div class="flex flex-col mx-auto items-center mt-3 max-w-2xl gap-3 mb-4">
      <h1 class="mb-2">{{ $t('navigation.about') }}</h1>
      <div v-if="about && about.length > 0">
        <h1 class="mb-2">{{ about[0].title }}</h1>
        <div id="content" v-html="about[0].content"></div>
      </div>
      <DirectusErrorView v-if="error" @retry="refresh" :status="status" />
    </div>
    <a id="faq" class="hidden"></a>
    <Faq />
    <Guidelines />
  </div>
</template>
<script setup lang="ts">
const { getSingletonItem } = useDirectusItems();
const locale = usePlatformSettings().locale;
const countryContentLocale = usePlatformSettings().countryContentLocale;
const countryCode = usePlatformSettings().countryCode;
const platform = usePlatformSettings().platformName;


const { data: about, error, refresh, status } = await useAsyncData<[]>(() => getSingletonItem<[]>({
  collection: 'd_about_translations',
  params: {
    fields: ['*', 'd_about_id.country.*'],
    filter: {
      languages_code: countryContentLocale.value,
      d_about_id: {
        platform: {
          name: platform.value
        },
        country:
          {
            code: countryCode.value
          }
      }
    }
  }
}), {
  watch: locale
});


</script>
<style scoped lang="postcss">

::v-deep(#content) {
  h2, h3, h4 {
    @apply leading-loose mt-[1em];
  }

  p {
    @apply leading-normal mt-[0.5em];
  }

  a {
    @apply text-theme-primary underline break-all;
  }

  ul {
    @apply ml-2 pt-0.5;

    li {
      @apply list-disc;
    }
  }
}

</style>
